import { render, staticRenderFns } from "./payroll-upload.vue?vue&type=template&id=986aecac&"
import script from "./payroll-upload.vue?vue&type=script&lang=js&"
export * from "./payroll-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports